import React from 'react';
import { motion } from 'framer-motion';
import { ClockIcon } from 'lucide-react';
export function Urgency() {
  return <section className="py-16 md:py-24 px-4 bg-heading text-white" data-id="element-294">
      <div className="max-w-4xl mx-auto text-center" data-id="element-295">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-296">
          <ClockIcon className="w-12 h-12 mx-auto mb-6" data-id="element-297" />

          <h2 className="font-heading text-3xl md:text-4xl font-bold mb-4" data-id="element-298">
            ⏰ Precio de lanzamiento disponible por tiempo limitado
          </h2>

          <p className="text-lg md:text-xl mb-8 opacity-90" data-id="element-299">
            Esta es la tarifa de introducción. Cuando se complete la fase de
            lanzamiento, el precio sube.
          </p>

          {/* Compact fuchsia price box with Comprar ahora button */}
          <motion.a href="https://www.tumundoequilibrado.com/cart/51443310887207:1" className="inline-flex flex-col sm:flex-row items-center gap-4 sm:gap-6 rounded-2xl px-6 py-5 sm:px-8 sm:py-6 text-white shadow-xl hover:shadow-2xl transition-all duration-300" style={{
          background: 'linear-gradient(135deg, #D6217A 0%, #E91E8C 50%, #FF3DA0 100%)'
        }} whileHover={{
          scale: 1.04
        }} whileTap={{
          scale: 0.96
        }} data-id="element-300">
            <div className="flex items-center gap-3 sm:gap-4" data-id="element-301">
              <div className="flex flex-col items-center leading-none" data-id="element-302">
                <span className="text-[10px] sm:text-xs uppercase tracking-wider opacity-80" data-id="element-303">
                  Antes
                </span>
                <span className="text-base sm:text-lg font-semibold line-through opacity-70" data-id="element-304">
                  $15,99
                </span>
              </div>
              <div className="w-px h-10 bg-white/40" data-id="element-305"></div>
              <div className="flex flex-col items-center leading-none" data-id="element-306">
                <span className="text-[10px] sm:text-xs uppercase tracking-wider opacity-90" data-id="element-307">
                  Ahora
                </span>
                <span className="font-heading text-2xl sm:text-3xl font-extrabold" data-id="element-308">
                  $11,99
                </span>
              </div>
            </div>
            <span className="bg-white text-[#D6217A] px-5 py-2.5 rounded-full font-bold text-sm sm:text-base shadow-md" data-id="element-309">
              🛒 Comprar ahora
            </span>
          </motion.a>
        </motion.div>
      </div>
    </section>;
}